import React from "react";

function TimelineItem(props) {
  return (
    <div className="timeline-item is-info">
      <div className="timeline-marker is-image is-32x32">
        <img src={props.x_icon} alt="" />
      </div>
      <div className="timeline-content">
        <p className="heading">{props.date}</p>
        <div className="timeline_title has-text-white">{props.company}</div>
        <p className="timeline_subtitle is-6 has-text-info">{props.position}</p>
        <ul>
          {buildSummaries(props.summary)}
        </ul>
        {/* <p style={{ maxWidth: "25em" }}>{props.summary}</p> */}

      </div>
    </div>
  );
}

function buildSummaries(summaries) {
  let result = [];
  let counter = 0;
  Object.entries(summaries).forEach(([key, value]) => {
    result.push(
      <li key={counter} className="timeline_summary">
        <div>{value}</div>
      </li>
    );
    counter++;
  });
  return result;
}


export default TimelineItem;
